// extracted by mini-css-extract-plugin
export default {"card":"Board_card__BJFbR"};